export default {
  methods: {
    normalizeMobileDeviceData(rawData, bookingField) {
      const fallback = {
        mobile_model_no: '',
        IMEI: '',
        active_date: '',
      };
      const source = rawData && typeof rawData === 'object' && !Array.isArray(rawData) ? rawData : {};
      const config = bookingField && bookingField.mobile_device ? bookingField.mobile_device : {};
      const data = Object.assign({}, fallback);

      Object.keys(config).forEach((key) => {
        if (!config[key] || typeof config[key] !== 'object') return;
        data[key] = typeof source[key] !== 'undefined' ? source[key] : this.getEmptyValue(config[key]);
      });

      return data;
    },
    buildCustomData(bookingRes, bookingField) {
      const list = [];
      const resultCustom = bookingRes && bookingRes.custom ? bookingRes.custom : [];
      const config = bookingField && bookingField.custom ? bookingField.custom : {};

      if (resultCustom.length) {
        resultCustom.forEach((item) => {
          const customer = { cus_type: item.cus_type };
          Object.keys(config).forEach((key) => {
            if (key === 'cus_type' || !config[key] || typeof config[key] !== 'object') return;
            if (typeof item[key] !== 'undefined') {
              customer[key] = item[key];
            } else {
              customer[key] = this.getDefaultCustomFieldValue(key, config[key]);
            }
          });
          list.push(customer);
        });
      } else if (config.cus_type && config.cus_type.use && config.cus_type.use.length) {
        config.cus_type.use.forEach((cusType) => {
          const customer = { cus_type: cusType };
          Object.keys(config).forEach((key) => {
            if (key === 'cus_type' || !config[key] || typeof config[key] !== 'object') return;
            customer[key] = this.getDefaultCustomFieldValue(key, config[key]);
          });
          list.push(customer);
        });
      }

      return list;
    },
    buildTrafficData(bookingRes, bookingField, requestData) {
      const list = [];
      const trafficConfigList = bookingField && bookingField.traffics ? bookingField.traffics : [];
      const resultTraffic = bookingRes && bookingRes.traffic ? bookingRes.traffic : [];

      trafficConfigList.forEach((config) => {
        const trafficType = config.traffic_type && config.traffic_type.traffic_type_value
          ? config.traffic_type.traffic_type_value
          : '';
        if (!trafficType) return;

        const existing = resultTraffic.find((item) => item.traffic_type === trafficType) || {};
        const traffic = {
          traffic_type: trafficType,
        };

        Object.keys(config).forEach((key) => {
          if (key === 'traffic_type' || !config[key] || typeof config[key] !== 'object') return;
          if (typeof existing[key] !== 'undefined' && existing[key] !== null && existing[key] !== '') {
            traffic[key] = existing[key];
          } else if (config[key].type === 'date') {
            traffic[key] = bookingRes && bookingRes.s_date ? bookingRes.s_date : requestData.s_date || '';
          } else if (trafficType === 'psg_qty') {
            traffic[key] = '0';
          } else {
            traffic[key] = this.getEmptyValue(config[key]);
          }
        });

        list.push(traffic);
      });

      return list;
    },
    buildMobileDeviceData(bookingRes, bookingField) {
      const result = bookingRes && bookingRes.mobile_device ? bookingRes.mobile_device : null;
      return this.normalizeMobileDeviceData(result, bookingField);
    },
    getEmptyValue(config) {
      if (!config) return '';
      if (config.type === 'boolean') return null;
      return '';
    },
    getDefaultCustomFieldValue(key, config) {
      if (key === 'nationality') return 'CN';
      return this.getEmptyValue(config);
    },
    initCountryParents() {
      this.countryParentMap = {};
      (this.booking.custom || []).forEach((item, index) => {
        if (item.country_cities && String(item.country_cities).indexOf('_') !== -1) {
          this.$set(this.countryParentMap, String(index), String(item.country_cities).split('_')[0]);
        }
      });
    },
    initContactToggles() {
      this.contactPhoneEnabledMap = {};
      this.contactAppEnabledMap = {};
      (this.booking.custom || []).forEach((item, index) => {
        if (item.cus_type !== 'contact') return;
        const hasPhone = !!(item.tel_number || item.tel_country_code);
        const hasApp = !!(item.contact_app || item.contact_app_account || item.has_app);
        const phoneRequired = this.isFieldVisible(this.getCustomFieldConfig('tel_number'), 'contact');
        const appRequired = this.isFieldVisible(this.getCustomFieldConfig('contact_app'), 'contact');
        this.$set(this.contactPhoneEnabledMap, String(index), hasPhone || phoneRequired);
        this.$set(this.contactAppEnabledMap, String(index), hasApp || appRequired);
        if (typeof item.has_app === 'undefined') {
          this.$set(item, 'has_app', hasApp || appRequired);
        }
      });
    },
    getSelectedSpecRefs() {
      if (!this.requestData || !this.requestData.skus) return [];
      return this.requestData.skus.reduce((result, item) => {
        return result.concat(item.specs_ref || []);
      }, []);
    },
    getPmdlProperties(moduleData) {
      if (!moduleData) return null;
      if (moduleData.content && moduleData.content.properties) return moduleData.content.properties;
      if (moduleData.properties) return moduleData.properties;
      return moduleData;
    },
    getVisibleCustomFields(cusType) {
      const fields = [];
      const config = this.bookingField && this.bookingField.custom ? this.bookingField.custom : {};
      Object.keys(config).forEach((key) => {
        if (key === 'cus_type' || !config[key] || typeof config[key] !== 'object') return;
        if (key === 'nationality') return;
        if (this.isFieldVisible(config[key], cusType)) {
          fields.push({ key, config: config[key] });
        }
      });
      return fields;
    },
    getVisibleTrafficFields(trafficType) {
      const config = (this.bookingField.traffics || []).find((item) => {
        return item.traffic_type && item.traffic_type.traffic_type_value === trafficType;
      });
      if (!config) return [];
      return Object.keys(config).filter((key) => key !== 'traffic_type' && config[key] && typeof config[key] === 'object')
        .map((key) => ({ key, config: config[key] }))
        .filter((field) => this.isRequired(field.config) || field.config.list_option || field.config.location_list || field.config.type);
    },
    getTrafficConfig(trafficType) {
      return (this.bookingField.traffics || []).find((item) => {
        return item.traffic_type && item.traffic_type.traffic_type_value === trafficType;
      }) || null;
    },
    isFieldVisible(config, cusType) {
      if (!config) return false;
      const use = config.use && Array.isArray(config.use) ? config.use.slice() : null;
      if (use && use.length) {
        const types = String(cusType).split(',').map((item) => item.trim());
        if (types.indexOf('cus_01') !== -1 && types.indexOf('cus_02') === -1) {
          types.push('cus_02');
        }
        return use.some((item) => types.indexOf(item) !== -1);
      }
      return this.isRequired(config);
    },
    isRequired(config) {
      if (!config) return false;
      if (typeof config.is_require === 'string') {
        return config.is_require === 'True' || config.is_require === 'true';
      }
      return !!config.is_require;
    },
    showBuyerField(fieldKey) {
      const pathMap = {
        first_name: 'booking.first_name',
        last_name: 'booking.last_name',
        tel: 'booking.tel',
        email: 'booking.email',
      };
      const config = this.getValue(this.bookingField, pathMap[fieldKey]);
      if (!config) return true;
      return this.isFieldVisible(config, 'cus_01');
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/shop/mixins/shopOrderDataMixin.js